import { SET_DARK_THEME ,SET_BLACK_OVERLAY } from '../actions/types';


const initialState = {
    darkTheme: false,
    blackOverlay : {is_closed : false , showModal : false , is_expired : false , expire_time : null},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_DARK_THEME:
            return {
                ...state,
                darkTheme: action.payload
            }
        case SET_BLACK_OVERLAY :{
            return {
                ...state,
                blackOverlay : action.payload
            }
        }
        default:
            return state;
    }
}